exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/_wks-ext.js
// module id = 202
// module chunks = 0